import { Redirect, Route, RouteProps } from 'react-router-dom';
import { UserService } from 'src/services/user.service';
import { clientRoutes } from 'src/shared/constants';
const jwtCheckExpiration = require('jwt-check-expiration');

export function PublicRoute(props: RouteProps) {
	const isAuthenticated = UserService.isAuthMSAuthenticated();
	return (
		<Route {...props}>
			{(isAuthenticated && props?.path === clientRoutes.signIn) ? (
				<Redirect
					to={{
						pathname: clientRoutes.dashboard,
						state: { from: props.path }
					}}
				/>
			) : props.children}
		</Route>
	);
}
